module.exports = __webpack_public_path__ + "static/media/icon-piece2-1.f2cb1cf8.png";